import React, { FC, HTMLAttributes, useState } from 'react';
import css from './ExpansionPanel.module.scss';
import classNames from 'classnames';

interface ExpansionPanelProps extends HTMLAttributes<HTMLDivElement> {
    title: string;
}

const cx = classNames.bind(css);

const ExpansionPanel: FC<ExpansionPanelProps> = ({ title, className, children }) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const toggleClick = () => {
        setIsOpen(prevState => !prevState)
    }
    return (
        <div className={ cx(css.wrapper) }>
            <button type="button" className={ cx(css.btn, className) } onClick={ toggleClick }>{ title }</button>
            { isOpen && children }
        </div>
    );
};

export default ExpansionPanel;
